import { useContext } from "react";

import { IconExclamationCircle } from "@btnet/blueprint-icons";

import { EnvironmentInfoContext } from "helpers/globalContext/EnvironmentInfoContext";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { GetEphDaysRemaining } from "commonComponents/utilities/MainNavigation/common/EphInfo/EphInfo";

function PublicEphBanner() {
    const envInfo = useContext(EnvironmentInfoContext);
    const ephRemainingDays = GetEphDaysRemaining(envInfo) ?? 0;
    if (envInfo?.isPublicEph !== true) {
        return null;
    }

    return (
        <BTAlert
            type="info"
            showIcon
            icon={<IconExclamationCircle size="lg" />}
            data-testid="publicEphAlert"
            className="PublicEphBanner"
            message={`You are viewing a test version of our website. This site is temporary and will be unavailable in ${ephRemainingDays} days.`}
        />
    );
}

export default PublicEphBanner;
